import React, { useState } from 'react';
import './UserManagerDialog.css';
import { auth, provider } from '../firebase';
import { signInWithPopup } from 'firebase/auth';

export default function UserManagerDialog({ open, onClose, onLogin }) {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGoogleLogin = async () => {
    setError(null);
    setLoading(true);
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const idToken = await user.getIdToken();
      // Send to backend
      const response = await fetch('https://devbite.vercel.app/auth/google', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ idToken, phoneNumber: phone,company: 'cakedoctor' }),
      });
      const data = await response.json();
      if (response.ok) {
        // Save user in localStorage
        localStorage.setItem('user', JSON.stringify(data.user));
        if (onLogin) onLogin(data.user);
        onClose();
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError(err.message || 'Google sign-in failed');
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;
  return (
    <div className="user-manager-modal-bg" onClick={onClose}>
      <div className="user-manager-sheet" onClick={e => e.stopPropagation()}>
        <div className="user-manager-bar" />
        <h2 className="user-manager-title">Sign In</h2>
        <input
          className="user-manager-input"
          type="tel"
          placeholder="Enter your phone number"
          value={phone}
          onChange={e => setPhone(e.target.value)}
        />
        <button className="user-manager-google-btn" onClick={handleGoogleLogin} disabled={loading}>
          <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="Google" className="user-manager-google-icon" />
          {loading ? 'Signing in...' : 'Login with Google'}
        </button>
        {error && <div className="user-manager-error">{error}</div>}
        <button className="user-manager-cancel-btn" onClick={onClose} disabled={loading}>Cancel</button>
      </div>
    </div>
  );
}
